import React from 'react'
import PropTypes from 'prop-types';
import ArrowIconRight from '@material-ui/icons/KeyboardArrowRight'
import Tr from 'translations/Translations'
import Button from "./Button";
import ArrowIconLeft from '@material-ui/icons/KeyboardArrowLeft'

export const Types = {
    PREV: "prev",
    NEXT: "next"
}

function PaginationButton(
    {
        type = Types.NEXT,
        config,
        setConfig = () => {
        },
        totalCount = 0,
        disabled
    }) {


    const changePage = () => {
        if (type === Types.NEXT) {
            const newPage = config.page + 1;
            if(totalCount >= newPage)
                setConfig({...config, page: newPage});
        }
        if (type ===Types.PREV) {
            const newPage = config.page - 1;
            if(newPage >= 1 && totalCount >= newPage )
                setConfig({...config, page: newPage});
        }
    }

    const variantDisabled = disabled || (type === Types.NEXT && config.page >= totalCount) || (type === Types.PREV && config.page <= 1)


    return (
        <Button
            color='primary'
            variant='text'
            onClick={changePage}
            disabled={variantDisabled}
        >
            {type === "prev" && <ArrowIconLeft/>}
            {type === "prev" ? Tr("previous") : Tr("next")}
            {type === "next" && <ArrowIconRight/>}
        </Button>

    )
}

PaginationButton.propTypes = {
    config: PropTypes.shape({
        page: PropTypes.number,
        pageSize: PropTypes.number
    }),
    setConfig: PropTypes.func,
    totalCount: PropTypes.number,
    disabled: PropTypes.bool,
    type: PropTypes.oneOf([Types.PREV, Types.NEXT])
}

export default PaginationButton;
